import { memo } from "react";
import { Tab } from "@ir/ui";
import { WorkspacePermissions } from "@/core/permissions";
import { HasAnyPermission } from "@/presentation/workspace";
import { TabType } from "@/store/deduction/drawer";
import { useDeductionDrawer } from "@/presentation/deduction/hooks";


const DeductionActivityTab = () => {
    const { isDeductionsLoading } = useDeductionDrawer();
    return (
        <HasAnyPermission requiredPermissions={[WorkspacePermissions.DEDUCTION_ACTIVITY_VIEW]}>
            <Tab id={TabType.ACTIVITY} aria-label={TabType.ACTIVITY} isDisabled={isDeductionsLoading} title={TabType.ACTIVITY}>
                {TabType.ACTIVITY}
            </Tab>
        </HasAnyPermission>
    )

}

DeductionActivityTab.displayName = "DeductionActivityTab";

export default memo(DeductionActivityTab);